import React from 'react';
import { Card } from '@usealloy/component-library';

import ImportedData from '~/entities/evaluations/imported-data/ImportedData';
import { useFetchedUserContext } from '~/helpers/hooks';
import type { FeatureFlags } from '~/helpers/typescript';

import { useEventTypeEvaluationsContext } from '../context';

const ImportedDataCard: React.FC = () => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const { feature_flags: featureFlags = {} as FeatureFlags } = useFetchedUserContext();

  const isWorkflowTypeReconciliation = evaluation.evaluation_type === 'reconciliation';
  const shouldShowImportedData = (
    featureFlags?.journeys
    && !isWorkflowTypeReconciliation
    && (
      evaluation.imported_outcome_reasons?.length > 0
      || evaluation.imported_output_attributes?.length > 0
      || evaluation.imported_matrix_models?.length > 0
    )
  );

  if (!shouldShowImportedData) {
    return null;
  }

  return (
    <Card
      header="Imported Data"
      collapsible
    >
      <ImportedData
        importedOutcomeReasons={evaluation.imported_outcome_reasons}
        importedOutputAttributes={evaluation.imported_output_attributes}
        importedMatrixModels={evaluation.imported_matrix_models}
      />
    </Card>
  );
};

export default ImportedDataCard;
